import React from 'react';
import PropTypes from 'prop-types';
import arrowBack from '../../../assets/Quotes/arrowBack.svg'
import './Buttons.css';

const EditInfoLink = props => {
  const showArrow = props.showArrow !== false;
  return (
    <a
      href={props.route}
      target="_parent"
      className="editInfoBtn d-flex align-items-center justify-content-center"
      onClick={props.handleClick}
    > 
      {showArrow ? <img src={arrowBack} alt="" /> : null}
      <span>{props.text}</span>
    </a>
  );
};

EditInfoLink.defaultProps = {
  text: 'back'
};

EditInfoLink.propTypes = {
  route: PropTypes.string,
  text: PropTypes.string,
  handleClick: PropTypes.func,
  showArrow: PropTypes.bool
};

export default EditInfoLink;
